import { render, staticRenderFns } from "./EventModalPassesHeader.vue?vue&type=template&id=4d18b198&scoped=true"
import script from "./EventModalPassesHeader.vue?vue&type=script&lang=js"
export * from "./EventModalPassesHeader.vue?vue&type=script&lang=js"
import style0 from "./EventModalPassesHeader.vue?vue&type=style&index=0&id=4d18b198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d18b198",
  null
  
)

export default component.exports